import javascript from "../../assets/technologies/javascript.svg";
import reactjs from "../../assets/technologies/react.svg";
import github from "../../assets/technologies/github.svg";
import NodeJs from "../../assets/technologies/nodejs.png"
import java from "../../assets/technologies/java.png"
import mysql from "../../assets/technologies/mysql.png"
import php from "../../assets/technologies/php.png"
import laravel from "../../assets/technologies/laravel.png"
import mongodb from "../../assets/technologies/mongodb.png"


export const iconsData = [
  {
    id: 3,
    icon: javascript,
    name: "JavaScript",
    href: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
  },
  {
    id: 4,
    icon: reactjs,
    name: "React",
    href: "https://reactjs.org/",
  },
    {
    id: 5,
    icon: mysql,
    name: "Microsoft SQL Server",
    href: "https://www.microsoft.com/",
  },

  {
    id: 6,
    icon: mongodb,
    name: "MongoDB",
    href: "https://www.adobe.com/products/illustrator.html",
  },
  {
    id: 7,
    icon: NodeJs,
    name: "NodeJs",
    href: "https://nodejs.org/en/",
  },
  {
    id: 8,
    icon: java,
    name: "Java",
    href: "https://www.java.com/en/",
  },
  {
    id: 9,
    icon: php,
    name: "PHP",
    href: "https://www.php.net/",
  },
  {
    id: 10,
    icon: laravel,
    name: "Laravel",
    href: "https://laravel.com/",
  },
  {
    id: 11,
    icon: github,
    name: "GitHub",
    href: "https://github.com/",
  },
];
